import React, { useState } from "react";
import { Link } from "react-router-dom"; // Import Link from react-router-dom
import logourl from "../assets/images/logo.png";

const Navbar = () => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const [hideTimeout, setHideTimeout] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMouseEnter = (item) => {
    if (hideTimeout) clearTimeout(hideTimeout);
    setHoveredItem(item);
  };

  const closeMenu = () => setIsMenuOpen(false);


  const handleMouseLeave = () => {
    const timeout = setTimeout(() => {
      setHoveredItem(null);
    }, 300);
    setHideTimeout(timeout);
  };

  const toggleMenu = () => setIsMenuOpen((prev) => !prev);

  const menuItems = [
    {
      label: "X-tremetuning Services",
      link: "/services",
      dropdown: [
        { label: "Chiptuning", link: "/Chip-Tuning" },
        { label: "Pops & Bangs", link: "/Pops-&-Bangs" },
        { label: "DPF Solutions", link: "/DPF-Solutions" },
        { label: "EGR Solutions", link: "/EGR-Solutions" },
        { label: "Start Stop", link: "/Start-Stop" },
        { label: "Exhaust Flap Control", link: "/Exhaust-Flap-Control" },
        { label: "Launch Control", link: "/Launch-Control" },
        { label: "Hard Rev Cut", link: "/Hard-Rev-Cut" },
        { label: "DTC Removal", link: "/DTC-Removal" },
        { label: "DSG / AUTOMAAT TUNING", link: "/DSG-Tuning" },
        { label: "ECO Tuning", link: "/ECO-Tuning" },
        { label: "ADBLUE Solutions", link: "/Adblue-Solutions" },
        {
          label: "Lambdasonde & NOx Solutions",
          link: "/Lambdasonde-&-NOx-Solutions",
        },
        { label: "V-Max", link: "/V-Max" },
      ],
    },
  ];

  return (
    <nav className="bg-black">
      <div className="container mx-auto px-4 py-4 sm:px-6 lg:px-12 flex justify-between items-center">
        {/* Logo */}
        <Link to="/" className="flex items-center" onClick={closeMenu}>
          <img src={logourl} alt="Logo" className="h-auto w-auto" />
        </Link>

        {/* Hamburger Menu Button */}
        <button
          className="lg:hidden text-[#fff] focus:outline-none"
          onClick={toggleMenu}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16m-7 6h7"
            />
          </svg>
        </button>

        {/* Desktop Menu */}
        <div className="hidden lg:flex items-center space-x-4 z-10">
          {menuItems.map((item, index) => (
            <div
              key={index}
              className="relative"
              onMouseEnter={() => handleMouseEnter(item.label)}
              onMouseLeave={handleMouseLeave}
            >
              <Link
                to={item.link}
                className="text-[#fff] hover:text-[#fff] font-medium px-3 py-2 rounded-md transition"
              >
                {item.label}
              </Link>
              {hoveredItem === item.label && (
                <div
                  className="absolute top-12 left-0 bg-black shadow-lg rounded-md w-48"
                  onMouseEnter={() => handleMouseEnter(item.label)}
                  onMouseLeave={handleMouseLeave}
                >
                  <ul className="text-sm text-white">
                    {item.dropdown.map((subItem, subIndex) => (
                      <li key={subIndex}>
                        <Link
                          to={subItem.link}
                          className="block px-4 py-2 hover:bg-gray-500"
                        >
                          {subItem.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}

          {/* Buttons */}
          <Link
            to="/Gallery"
            className="text-white px-4 py-2 rounded-md transition"
          >
            Gallery
          </Link>
          <Link
            to="/contact-us"
            className="bg-[#BD0E0E] text-white px-4 py-2 rounded-md hover:bg-[#BD0E0E] transition"
          >
            Contact Us
          </Link>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <>
            {/* Background Overlay */}
            <div
              className="fixed inset-0 bg-black bg-opacity-50 z-10"
              onClick={toggleMenu}
            ></div>
            <div
              className="fixed top-0 left-0 w-3/4 h-screen bg-black shadow-lg z-20 overflow-y-auto"
              style={{ transition: "transform 0.3s ease-in-out" }}
            >
              <div className="flex flex-col space-y-4 p-6">
                {menuItems.map((item, index) => (
                  <div key={index} className="relative">
                    <Link
                      to={item.link}
                      className="text-white font-medium text-lg"
                      onClick={closeMenu}
                    >
                      {item.label}
                    </Link>
                    {item.dropdown && (
                      <ul className="mt-2 pl-4 space-y-2 text-sm text-white">
                        {item.dropdown.map((subItem, subIndex) => (
                          <li key={subIndex}>
                            <Link
                              to={subItem.link}
                              className="block py-1 hover:text-[#BD0E0E]"
                              onClick={closeMenu}
                            >
                              {subItem.label}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
                <Link
                  to="/Gallery"
                  className="text-white px-4 py-2 rounded-md transition"
                  onClick={closeMenu}
                >
                  Gallery
                </Link>
                <Link
                  to="/contact-us"
                  className="bg-[#BD0E0E] text-white px-4 py-2 rounded-md hover:bg-[#BD0E0E] transition"
                  onClick={closeMenu}
                >
                  Contact Us
                </Link>
              </div>
            </div>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
